import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

/** Snackbar notification component that displays a title, message, and icon for transient user feedback. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'qiasphere-generic-snackbar-dialog',
  templateUrl: './generic-snackbar.component.html',
  styleUrls: ['./generic-snackbar.component.scss'],
  imports: [MatIcon]
})
export class GenericSnackbarComponent {
  data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
}

export type SnackbarData = { title: string; message: string; icon: string };
